import supabase, { isSupabaseConfigured } from './supabaseClient';

export async function getPublicRows(table, order = 'sort_order', filterVisible = true) {
  if (!isSupabaseConfigured) return { data: null, error: new Error('Supabase is not configured.') };
  let query = supabase.from(table).select('*');
  if (filterVisible) query = query.eq('visible', true);
  const result = await query.order(order);
  if (table === 'service_master' && result.data) {
    return {
      ...result,
      data: result.data.filter((item) => {
        const name = (item.name || '').toLowerCase();
        const desc = (item.description || item.desc || '').toLowerCase();
        const id = (item.id || '').toLowerCase();
        return (
          !name.includes('self drive') &&
          !name.includes('self-drive') &&
          !desc.includes('freedom to drive') &&
          !id.includes('elf_rive')
        );
      }),
    };
  }
  return result;
}

export async function getPublicSettings(key) {
  if (!isSupabaseConfigured) return { data: null, error: new Error('Supabase is not configured.') };
  const result = await supabase.from('site_settings').select('value').eq('key', key).eq('public_visible', true).maybeSingle();
  return { data: result.data?.value || null, error: result.error };
}

export const listPublicReviews = () => getPublicRows('reviews', 'sort_order');
export const listPublicFaqs = () => getPublicRows('faqs', 'sort_order');
